/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppStateGateway } from '@cigna/cigna-for-brokers/shared/gateways';
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
import { lastValueFrom } from 'rxjs';
import { SignJWT } from 'jose';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private _http: HttpClient,
    private _gw: AppStateGateway,
    private _appStateFacade: AppstateFacade,
  ) {}

  async preLoadProfile(ssoId: string) {
    const secret = this._gw.profilePreLoadKey().trim();
    const audience = 'cignaforbrokers_identity_profile_login';
    let hostName = window.location.origin;
    hostName = hostName.includes('localhost')
      ? 'https://int2.cignaforbrokers.com'
      : hostName;
    const iat = Math.floor(new Date().getTime() / 1000) - 6 * 60 * 60 - 3 * 60;
    const exp = Math.floor(new Date().getTime() / 1000) + 6 * 60 * 60 + 3 * 60;

    const jwt = await new SignJWT({
      sub: ssoId,
    })
      .setProtectedHeader({
        typ: 'JWT',
        alg: 'HS512',
        kid: 'symmetricJWT',
      })
      .setIssuer(hostName)
      .setAudience(audience)
      .setExpirationTime(exp)
      .setIssuedAt(iat)
      .sign(this.b64ToArrayBuffer(secret));

    const httpOptions = await {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${jwt}`,
      }),
    };
    return lastValueFrom(
      this._http.get<any>(this._gw.profilePreLoad(), httpOptions),
    );
  }

  b64ToArrayBuffer(strToEncode: string) {
    const binaryStr = window.atob(strToEncode);
    const bytes = new Uint8Array(binaryStr.length);

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < binaryStr.length; i++) {
      bytes[i] = binaryStr.charCodeAt(i);
    }
    return bytes;
  }

  trackEnrolledContact(enrolledContact: string | null) {
    if (enrolledContact === 'Mobile') {
      this._appStateFacade.sendAnalytics({
        event: 'pageAction',
        reqData: {
          requirementId: 'acCFBMFA007',
          userStory: 'MTD-2650',
          hitType: 'action',
        },
        actionData: {
          widgetName: 'sms-verify-success',
          customLinkText: 'SMS Verified',
        },
      });
    } else if (enrolledContact === 'Email') {
      this._appStateFacade.sendAnalytics({
        event: 'pageAction',
        reqData: {
          requirementId: 'acCFBMFA010',
          userStory: 'MTD-2653',
          hitType: 'action',
        },
        actionData: {
          widgetName: 'email-verify-success',
          customLinkText: 'Email Verified',
        },
      });
    }
  }
}
